import { observer } from 'mobx-react';
import React from 'react';
import { Link } from 'react-router-dom';
import { IconPec1, IconPec2, IconPec3, IconPec4, IconPec5 } from './Icon';

const StepFlowComponent = observer(() => {
    const steps = [
        {
            id: 1,
            // icon: '/images/i-pec-1.png',
            icon: <IconPec1 />,
            title: 'Step1',
            description: (
                <>PECSに<br />事前登録</>
            )
        },
        {
            id: 2,
            // icon: '/images/i-pec-2.png',
            icon: <IconPec2 />,
            title: 'Step2',
            description: (
                <>エレファントへ<br />登録・受講プラン購入</>
            )
        },
        {
            id: 3,
            // icon: '/images/i-pec-3.png',
            icon: <IconPec3 />,
            title: 'Step3',
            description: (
                <>受講講座を<br />選択・視聴完了</>
            )
        },
        {
            id: 4,
            // icon: '/images/i-pec-4.png',
            icon: <IconPec4 />,
            title: 'Step4',
            description: (
                <>確認問題を<br />解く・受講完了</>
            )
        },
        {
            id: 5,
            // icon: '/images/i-pec-5.png',
            icon: <IconPec5 />,
            title: 'Step5',
            description: (
                // <>PECSで<br />認定申請</>
                <>
                    PECS
                    <br />
                    単位反映
                    <br className='alway-show' />
                    <span style={{
                        color: '#F60018',
                        fontSize: 12,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: 6,
                        whiteSpace: 'nowrap'
                    }}
                    >
                        ※毎週elephamtよりPECSへ単位反映
                    </span>
                </>
            )
        }
    ];

    const TextStep = (stepNumber, description) => {
        if (stepNumber === 1) {
            return (
                <Link
                    to={'https://pecs.jpec.or.jp/_/pharmacist/'}
                    target="_blank"
                    className="step-link"
                >
                    {description}
                </Link>
            );
        } else if (stepNumber === 2) {
            return (
                <Link
                    to={'https://elephamt.jp/registration/first-step'}
                    target="_blank"
                    className="step-link"
                >
                    {description}
                </Link>
            );
        }
        return <>{description}</>;
    };

    return (
        <div className="step-flow">
            <div className="step-flow__container">
                {steps.map((step, index) => (
                    <React.Fragment key={step.id}>
                        <div className="step-flow__item">
                            <div className="step-flow__icon-wrapper">
                                {/* <img src={step.icon} alt="" className="step-icon" /> */}
                                {step.icon && step.icon}
                            </div>
                            <div className="step-flow__badge">
                                <span className="step-flow__badge__step">Step</span>
                                <span className="step-flow__badge__number">{index + 1}</span>
                            </div>
                            <div className="step-flow__description">
                                {TextStep(index + 1, step.description)}
                            </div>
                        </div>
                        {index < steps.length - 1 && (
                            <div className="step-flow__arrow">
                                <svg
                                    width="20"
                                    height="23"
                                    viewBox="0 0 20 23"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M19.1305 11.7212L0.480469 0.951172V22.4912L19.1305 11.7212Z"
                                        fill="#4EA953"
                                    />
                                </svg>
                            </div>
                        )}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
});

export default StepFlowComponent;
